<template>
    <div id="notePadReviewReport">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Note Pad Review </div>
                    <div class="web-action-btn btn-groups text-right">
                        <!-- Button for Clear Cache -->
                        <!-- <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-ar-report">
                        <data-table-filter-config :moduleName="'notePadReview'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                        <section class="data-table bg-white">
                            <custom-pagination
                                :page-changed="onPageChange"
                                :per-page-changed="onPerPageChange" :moduleName="'notePadReview'" :position="'top'">
                            </custom-pagination>
                            <vue-good-table
                                ref="NotePadReview"
                                mode="remote"
                                title="Note Pad Review"
                                @on-page-change="onPageChange"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange"
                                @on-sort-change="onSortChange"
                                @on-select-all="onSelectAll"
                                @on-selected-rows-change="selectionChanged"
                                :totalRows="totalRecords"
                                :columns="userColumns"
                                :rows="rows"
                                :pagination-options="{
                                    enabled: false,
                                    position: 'both',
                                    perPage: perPage,
                                    perPageDropdown:dropDownPerPage,
                                    dropdownAllowAll: false,
                                }"
                                :select-options="{
                                    enabled: false,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                }"
                                :search-options="{
                                    enabled: false,
                                }">
                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <div v-if="props.column.field == 'note_comments'">
                                            <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                        </div>
                                        <div v-else>
                                            {{props.formattedRow[props.column.field]}}
                                        </div>
                                    </div>
                                </template>
                            </vue-good-table>
                            <custom-pagination
                                :page-changed="onPageChange"
                                :per-page-changed="onPerPageChange">
                            </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./../event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
let msgServer;
export default {
    name: "NotePadReviewReport",
    metaInfo() {
        return {
            title: "Note Pad Review | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        batchProcess:0,
        batchNum:"",
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label: 'Note Type',
                field: 'note_type_i',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                sortable : false,
            },
            {
                label: 'Note Type Descr',
                field: 'note_type',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
            },
            {
                label: 'Note Category',
                field: 'note_category',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Note Key',
                field: 'note_key',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                sortable:false
            },
            {
                label: 'Entity',
                field: 'entity',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                sortable:false
            },
            {
                label: 'Entity Name',
                field: 'entity_name',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                sortable:false
            },
            {
                label: 'Phone Number',
                field: 'phone_number',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                sortable:false
            },
            {
                label: 'Invoice',
                field: 'invoice_number',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                sortable:false
            },
            {
                label: 'Transaction Description',
                field: 'trans_desc',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                sortable:false
            },
            {
                label: 'Invoice Amount Original',
                field: 'invoice_amount_original',
                filterable: true,
                fpFieldType:"integer",
                hidden:false,
                type: 'number',
                sortable:false
            },
            {
                label: 'Invoice Amount Open',
                field: 'invoice_amount_open',
                filterable: true,
                fpFieldType:"integer",
                type:'number',
                hidden:false,
                sortable:false
            },
            {
                label: 'Note Nbr',
                field: 'note_nbr',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                sortable:false
            },
            {
                label: 'Note Seq',
                field: 'note_seq',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                sortable:false
            },
            {
                label: 'Note Created Date',
                field: 'note_created_date',
                fpFieldType:"custom_date",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Note Header',
                field: 'note_header',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Note Comments',
                field: 'note_comments',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: 'User Created',
                field: 'user_created',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: 'User Sent To',
                field: 'user_assigned_to',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Follow Up Date',
                field: 'follow_up_date',
                filterable: true,
                fpFieldType:"custom_date",
                hidden:false,
            },
            {
                label: 'Completed Date',
                field: 'completed_date',
                filterable: true,
                fpFieldType:"custom_date",
                hidden:false,
            },
            {
                label: 'Completed Code',
                field: 'completed',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Priority Code',
                field: 'priority',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Secure',
                field: 'secure',
                filterable: false,
                fpFieldType:"text",
                hidden:false,
                sortable:false
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        action:'list'
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'note_pad_review_report') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
    },
    beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
        msgServer.close();
    },
    created: function() {

    },
    mounted: function() {
        var self = this;

        self.getPermissions();

    },
    methods: {
        cancelAll: function (cancelAll) {
          this.$refs.NotePadReview.unselectAllInternal();
        },
        loadList: function() {
            var self = this;

            var selectedRows = [];
            var data = this.$refs['NotePadReview'].selectedRows;
            for ( var i = 0; i < data.length; i++ ) {
                selectedRows.push(this.$refs['NotePadReview'].selectedRows[i].id)
            }

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action: self.action,
                selectedAll:self.serverParams.selectedAll,
                selectedRows:selectedRows,
            };

            self.firstLoad = 1;
            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/report/note-pad-review",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                      if ( self.action == "export" ||  self.action == "export_queue") {

                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {
                            if ( self.action == "export" ) {
                                self.excel = data.content.web;
                                var save = document.createElement("a");
                                save.href = self.excel;
                                save.download = data.content.web;
                                save.target = "_blank";

                                document.body.appendChild(save);
                                save.click();
                                document.body.removeChild(save);
                            } else {
                                self.batchProcess = 1;
                                self.batchNum = data.content;
                            }
                          }
                        self.action = "list";
                        self.loadList();
                        return;

                      } else {
                          self.rows = data.content.row;
                          self.totalRecords = data.content.totalRecords;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'note-pad-review')
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/NotePadReviewReport.vue